import React, { FC } from "react";
import { shallowEqual } from "react-redux";
import { useAppDispatch } from "../../../store/hooks/dispatch.hook";
import { useAppSelector } from "../../../store/hooks/selector.hook";
import { getGroupsListForVendorFetch, setGroups, setGroupsFilter, setPageGroups } from "../../../store/state/groups/groups.slice";
import { configListAdapter } from "../../../utl/adapters/ConfigListAdapter";
import { culcPage } from "../../../utl/helpers/culcPage";
import { Filter } from "../../../utl/models/Filters";
import DropdownFilter, { DropdownFilterItem } from "../../Services/Basics/components/DropdownFilter/DropdownFilter";


const TypeFilter: FC = () => {
    const types = useAppSelector(state => state.config.vendorConfig?.service.types, shallowEqual);
    const typesList = configListAdapter(types);

    const dropdownList: DropdownFilterItem[] = typesList.map(type => ({ name: type.name, value: String(type.id) }));
    dropdownList.push({
        name: "Всі",
        value: "undefined"
    });

    const vendorId = useAppSelector(state => state.user.vendorId, shallowEqual) || -1;

    const confirmed = useAppSelector(state => state.groups.filter.confirmed, shallowEqual);
    const active = useAppSelector(state => state.groups.filter.active, shallowEqual);

    const typeId = useAppSelector(state => state.groups.filter.typeId, shallowEqual);
    const value = String(typeId);

    const categoryId = useAppSelector(state => state.groups.filter.categoryId, shallowEqual);

    const page = 1;
    const totalCount = 0;
    const pageAll = 0;
    const pageSize = useAppSelector(state => state.groups.pageSize, shallowEqual);
    const getAllItems = useAppSelector(state => state.groups.getAllItems, shallowEqual);
    const pagesRange = culcPage(page, pageAll, totalCount, pageSize);

    const dispatch = useAppDispatch();

    const changeHandler = (value: string) => {
        let filter: Filter = {
            confirmed,
            categoryId,
            active,
        };

        if (!getAllItems) {
            filter.range = {
                from: pagesRange.from,
                to: pagesRange.to
            }
        }

        if (value.localeCompare('undefined') !== 0) {
            const typeIdValue = parseInt(value);

            filter.typeId = typeIdValue;

            dispatch(setGroupsFilter({ typeId: typeIdValue, confirmed, categoryId }));
        } else {
            dispatch(setGroupsFilter({ typeId: undefined, confirmed, categoryId }));
        }

        dispatch(setGroups({ groups: [] }));
        dispatch(getGroupsListForVendorFetch({ vendorId, filter }));
        dispatch(setPageGroups({ page }));
    }

    return (
        <DropdownFilter
            label="Тип"
            changeHandler={changeHandler}
            dropdownList={dropdownList}
            value={value}
            maxWidth={200}
        />
    )
}

export default TypeFilter;